import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

const FooterLink = (props) => {
  const { to, href, label } = props;

  if (href) {
    return (
      <StyledLink as="a" href={href} target="_blank" rel="noopener">
        {label}
      </StyledLink>
    );
  }
  return <StyledLink to={to}>{label}</StyledLink>;
};

const StyledLink = styled(Link)`
  display: block;
  font-size: 15px;
  margin-bottom: 12px;
  text-decoration: none;
  padding-right: 10px;
`;

export default FooterLink;
